
        var result = require("!!../../../../node_modules/css-loader/index.js!./providers.component.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/manage/providers/providers.component.css
// module id = 729
// module chunks = 0